import { Component } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NotificationService } from 'src/app/services/notification.service';
import { UserService } from 'src/app/services/user.service';
import { SupportService } from 'src/app/support.service';
import { User, WriteOffMoneyDoc } from 'src/typings';

import { WiteOffMoneyService } from '../wite-off-money.service';

@Component({
  selector: 'app-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.scss']
})
export class UpdateComponent {
  id: number | undefined;

  doc: WriteOffMoneyDoc | undefined;

  private subscription: Subscription;

  user: User | undefined;

  dialogRef: MatDialogRef<UpdateComponent> | undefined;

  constructor(
    public dialog: MatDialog,
    private fb: UntypedFormBuilder,
    private writeOffService: WiteOffMoneyService,
    private router: Router,
    private userService: UserService,
    private activateRoute: ActivatedRoute,
    public supportService: SupportService,
    private notificationService: NotificationService
  ) {
    this.subscription = activateRoute.params.subscribe((params) => {
      this.id = params.id;
      this.userService.user.subscribe((user) => {
        this.user = user;
      });
      if (this.id) {
        this.writeOffService.getOne(params.id).subscribe((doc) => {
          this.doc = doc;
          this.loadDoc();
        });
      }
    });
  }

  createForm: UntypedFormGroup = this.fb.group({
    value: new UntypedFormControl(),
    description: new UntypedFormControl(),
    bank: new UntypedFormControl(),
    date: new UntypedFormControl(new Date()),
    commission: new UntypedFormControl()
  });

  get date() {
    return this.createForm.controls.date.value;
  }

  get dateFormControl(): UntypedFormControl {
    return this.createForm.controls.date as UntypedFormControl;
  }

  get commission() {
    return this.createForm.controls.commission.value;
  }

  get commissionFormControl(): UntypedFormControl {
    return this.createForm.controls.commission as UntypedFormControl;
  }

  get bank() {
    return this.createForm.controls.bank.value;
  }

  get bankFormControl(): UntypedFormControl {
    return this.createForm.controls.bank as UntypedFormControl;
  }

  get value() {
    return this.createForm.controls.value.value;
  }

  get valueFormControl(): UntypedFormControl {
    return this.createForm.controls.value as UntypedFormControl;
  }

  get description() {
    return this.createForm.controls.description.value;
  }

  get descriptionFormControl(): UntypedFormControl {
    return this.createForm.controls.description as UntypedFormControl;
  }

  loadDoc() {
    if (!this.doc) return this.notificationService.warning('Не могу найти документ!');
    if (this.doc.date) this.dateFormControl.setValue(this.doc.date);
    if (this.doc.description) this.descriptionFormControl.setValue(this.doc.description);
    if (this.doc.bank) this.bankFormControl.setValue(this.doc.bank);
    if (this.doc.value) this.valueFormControl.setValue(this.doc.value);
    if (this.doc.commission) this.commissionFormControl.setValue(this.doc.commission);
  }

  save() {
    if (this.doc) {
      this.writeOffService
        .save({
          id: this.doc.id,
          description: this.description,
          bank_id: this.bank.id,
          value: this.value,
          date: this.date,
          passed: this.doc.passed,
          commission: this.commission
        })
        .subscribe(
          () => {
            if (!this.dialogRef) {
              this.router.navigateByUrl('/docs/write_off_money/list');
            } else {
              this.dialogRef.close();
            }

            this.notificationService.notice(`Документ №${this.id} сохранен!`);
          },
          (err) => {
            this.notificationService.warning(err.error.message);
          }
        );
    } else {
      this.writeOffService
        .create({
          description: this.description,
          bank_id: this.bank.id,
          value: this.value,
          date: this.date,
          commission: this.commission,
          passed: false
        })
        .subscribe(
          (doc) => {
            if (!this.dialogRef) {
              this.router.navigateByUrl('/docs/write_off_money/list');
            } else {
              this.dialogRef.close();
            }
            this.notificationService.notice(`Документ №${doc.id} сохранен!`);
          },
          (err) => {
            this.notificationService.warning(err.error.message);
          }
        );
    }
  }
}
